<section>
  <div flex fxLayout="column" fxLayoutAlign="center"></div>
</section>

<div>
  <p>Bitte wählen Sie den neuen Status für die Registrierung aus und geben Sie einen Kommentar ein.</p>
</div>

<form [formGroup]="currentForm">
  <section fxLayout="column" fxLayoutAlign=" start">
    <div class="wrapper">
      <div class="col" fxFlex="100">
        <mat-form-field appearance="outline">
          <mat-label>Neuer Status</mat-label>
          <mat-select formControlName="newState">
            <mat-option *ngFor="let ele of metaService.gridRegistrationStatus" [value]="ele.value">
              {{ ele.displayName }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>

    <mat-form-field appearance="outline" style="margin-bottom: 0.5rem" fxFlexAlign="stretch">
      <mat-label>Kommentar:</mat-label>
      <textarea
        matInput
        type="text"
        placeholder="Kommentar"
        rows="3"
        required
        maxlength="255"
        formControlName="comment"></textarea>
    </mat-form-field>
  </section>
</form>

<div class="button-container" fxLayout="row" fxLayoutAlign="end stretch" fxLayoutGap="20px">
  <button mat-stroked-button color="primary" id="modal-cancel-button" (click)="cancel()">Abbrechen</button>
  <button mat-raised-button color="primary" id="modal-confirm-after-meter-change" (click)="confirm()">
    <span>Status ändern</span>
  </button>
</div>
